import React from "react";
import { langStore, translate } from "@noli/business";
import { themeStore } from "@/stores/theme";
import { Avatar, Box, calc, Center, Flex, Image, Stack, Text } from "@chakra-ui/react";
import { ReactComponent as LogoSvg } from "@/assets/icons/logo.svg";
import { ReactComponent as LogoText } from "@/assets/icons/logo_nolibox.svg";
import { LEFT_WIDTHS } from "@/utils/constants";
import Icon from "@/components/Icon";
import Select from "@/components/Select";
import { genBlock } from "@/utils/bem";
import { observer } from "mobx-react-lite";
import { loginStore } from "@/modules/login/store";
import loginImage from "@/assets/images/login/login_bg.png";
import aigcAssistant from "@/assets/images/login/aigc_assistant.png";
import fingerDown from "@/assets/images/login/emoji_finger_down.png";
import { useResponsive } from "@/utils/style";
import { HeaderWithLogin } from "@/modules/login/ui";

const block = genBlock("noPermission");

const getGradient = (textClip: boolean) => {
  return textClip
    ? {
        background: "linear-gradient(62.68deg, #00FFAC 8.91%, #00FFFF 82.97%)",
        WebkitBackgroundClip: "text",
        webkitTextFillColor: "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
      }
    : {
        background: "linear-gradient(62.68deg, #00FFAC 8.91%, #00FFFF 82.97%)",
      };
};

const productStroke = {
  background: `linear-gradient(-90deg, #BFF881 0%,#A8F183 2.53%,#9BE986 18.83%,#95E39A 35.48%,#8CDEBE 50.82%,#7DD1D7 65.86%,#75D1D9 79.52%,#6FD9D3 95.14%,#6BAFD6 100%)`,
};

function NoPermission(props: any) {
  const calcPx = useResponsive();
  const size = "64px";
  const lang = langStore.tgt;

  return (
    <Flex
      minW="1280px"
      w="100%"
      bgColor="#010D1F"
      flexShrink={0}
      bgImage={loginImage}
      bgRepeat="no-repeat"
      bgPos="top center"
      bgSize="contain"
    >
      <HeaderWithLogin />
      {/* 上面是header */}
      <Flex
        flexDirection="column"
        paddingTop={size}
        className={block({ e: "main" })}
        alignItems="center"
        w="100%"
        h="100vh"
        overflowY="hidden"
        color="#fff"
      >
        <Flex
          fontWeight="900"
          fontSize="64px"
          className={block({ e: "title" })}
          marginTop={calcPx(170)}
        >
          <Icon svg={LogoText} style={{ width: "auto", height: "auto" }} attrs={{ height: 64 }} />
          <Text css={getGradient(true)}>Creator</Text>
        </Flex>
        <Stack
          height={calcPx(200)}
          align="center"
          style={{ marginTop: "3%", marginBottom: "-2.5%" }}
        >
          <Text
            align="center"
            fontSize={calcPx(72)}
            fontWeight={600}
            textShadow="0px 0px 32px #000000"
          >
            极具创意的 AI艺术家，快来申请内测权限
          </Text>
          <Image src={fingerDown} w={calcPx(140)} h={calcPx(140)}></Image>
        </Stack>
        <Center>
          <Flex
            as="a"
            href="https://f8y4v1rln8.feishu.cn/share/base/form/shrcn7jOfTaZxVhdJhmK69iI98c"
            target="_blank"
            justifyContent="center"
            alignItems="center"
            w={calcPx(200)}
            h={calcPx(60)}
            borderRadius="full"
            textAlign="center"
            color="black"
            cursor="pointer"
            fontSize={calcPx(24)}
            mt={calcPx(120)}
            css={getGradient(false)}
          >
            <Text>申请内测</Text>
          </Flex>
        </Center>
        <Box
          w={calcPx(130)}
          h={calcPx(130)}
          right={calcPx(85)}
          bottom={calcPx(85)}
          position="fixed"
          _after={{
            content: "'扫码咨询绿色通道'",
            pos: "absolute",
            bottom: "110%",
            fontSize: calcPx(16),
            width: "100%",
            left: 0,
            textAlign: "center",
          }}
          _before={{
            pos: "absolute",
            top: 0,
            left: 0,
            ...productStroke,
            width: "100%",
            height: "100%",
            content: '""',
            filter: "blur(8px)",
            rounded: calcPx(4),
            p: calcPx(4),
          }}
          css={productStroke}
          rounded={calcPx(4)}
          p={calcPx(4)}
          flexShrink={0}
          className={block({ e: "viewImage" })}
        >
          <Image
            pos="relative"
            w="100%"
            draggable="false"
            src={aigcAssistant}
            display="block"
          ></Image>
        </Box>
      </Flex>
    </Flex>
  );
}

export default observer(NoPermission);
